/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Sub_Addons_Confirm_Upgrade_Title_ChangeInputs */



/**
* | output |
* | --- |
* | "Upgrade to {label}" |
*
* @param {Sub_Addons_Confirm_Upgrade_Title_ChangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_upgrade_title_change = /** @type {((inputs: Sub_Addons_Confirm_Upgrade_Title_ChangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Upgrade_Title_ChangeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Auf ${i?.label} upgraden`)
	return /** @type {LocalizedString} */ (`Upgrade to ${i?.label}`)
});